import React from "react";
import Icon from "components/AppIcon";


export default function CompareBar({ selectedCount, onClear, onCompare }) {
  if (selectedCount === 0) return null;
  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-4 px-5 py-3 bg-primary text-white rounded-full shadow-xl z-40"
      style={{ minWidth: "280px" }}
    >
      <Icon name="GitCompare" size={18} color="white" />
      <span className="text-sm font-caption font-medium flex-1">
        {selectedCount} deal{selectedCount > 1 ? "s" : ""} selected
      </span>
      <button onClick={onCompare} className="text-sm font-caption font-semibold underline hover:no-underline">
        Compare
      </button>
      <button onClick={onClear} className="p-1 rounded-full hover:bg-white/20 transition-colors">
        <Icon name="X" size={16} color="white" />
      </button>
    </div>
  );
}